import { createContext, useContext } from 'react';
import { ToastTone, ToastAction } from './Toast.js';

export interface ToastOptions {
  id?: string;
  tone?: ToastTone;
  message: string;
  action?: ToastAction;
  durationMs?: number;
}

export interface ToastContextValue {
  toast: (options: ToastOptions) => string;
  success: (message: string, action?: ToastAction) => string;
  error: (message: string) => string;
  info: (message: string, action?: ToastAction) => string;
  warning: (message: string) => string;
  undo: (message: string, onUndo: () => void, durationMs?: number) => string;
  dismiss: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export const useToast = (): ToastContextValue => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
